<template lang="html">
  <root class="admin-business-edit">

    <admin-nav></admin-nav>
    <page-header name="Edit business" :count="false"></page-header>

    <!-- Form -->
    <div class="container">
      <div class="row">
        <div class="col m6">
          <div class="row">
            <div class="col m6">
              <div class="mui-textfield">
                <label>Name (EN)</label>
                <input type="text" v-model="business.name.en">
              </div>
            </div>

            <div class="col m6">
              <div class="mui-textfield">
                <label>Name (AR)</label>
                <input type="text" v-model="business.name.ar">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col m6">
              <div class="mui-textfield">
                <label>Description (EN)</label>
                <textarea class="materialize-textarea" v-model="business.description.en"></textarea>
              </div>
            </div>

            <div class="col m6">
              <div class="mui-textfield">
                <label>Description (AR)</label>
                <textarea class="materialize-textarea" v-model="business.description.ar"></textarea>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col m12">
              <div class="mui-select">
                <select v-model="city" @change="chooseCity">
                  <option v-for="city in cities" :value="city.key" :disabled="__isChoosen(city.key)">{{ city.name.en }}</option>
                </select>
                <label>Cities</label>
              </div>

              <div class="chip" v-for="city in business.cities" @click="unchooseCity(city)">
                {{ __cityName(city) }} <i class="material-icons">close</i>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col m6">
              <div class="mui-textfield">
                <label>Delivery time (EN)</label>
                <input type="text" v-model="business.delivery_time.en">
              </div>
            </div>
            <div class="col m6">
              <div class="mui-textfield">
                <label>Delivery time (AR)</label>
                <input type="text" v-model="business.delivery_time.ar">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col m12">
              <div class="file-field input-field">
                <div class="btn">
                  <span>Display photo</span>
                  <input type="file" accept="image/jpeg" :disabled="isSending" @change="uploadPhoto('display', $event)">
                </div>
                <div class="file-path-wrapper">
                  <input class="file-path validate" placeholder="Compressed .jpeg, 1:1">
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col m12">
              <div class="file-field input-field">
                <div class="btn">
                  <span>Cover photo</span>
                  <input type="file" accept="image/jpeg":disabled="isSending" @change="uploadPhoto('cover', $event)">
                </div>
                <div class="file-path-wrapper">
                  <input class="file-path validate" placeholder="Compressed .jpeg, 1:1">
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col m12">
              <div class="mui-textfield">
                <label>Deeplink hash</label>
                <input type="text" v-model="business.deeplink_hash">
              </div>
            </div>
          </div>
        </div>

        <div class="col m6">
          <table class="bottom-line">
            <tbody>
              <tr>
                <th>Name (EN)</th>
                <td>{{business.name.en}}</td>
              </tr>
              <tr>
                <th>Name (AR)</th>
                <td>{{business.name.ar}}</td>
              </tr>
              <tr>
                <th>Description (EN)</th>
                <td>{{business.description.en}}</td>
              </tr>
              <tr>
                <th>Description (AR)</th>
                <td>{{business.description.ar}}</td>
              </tr>
              <tr>
                <th>Cities</th>
                <td>
                    <span v-for="city in business.cities">{{ __cityName(city) }}, </span>
                </td>
              </tr>
              <tr>
                <th>Delivery time (EN)</th>
                <td>{{business.delivery_time.en}}</td>
              </tr>
              <tr>
                <th>Delivery time (AR)</th>
                <td>{{business.delivery_time.ar}}</td>
              </tr>
              <tr>
                <th>Display photo</th>
                <td><img :src="displayPhotoPreview" class="photo"></td>
              </tr>
              <tr>
                <th>Cover photo</th>
                <td><img :src="coverPhotoPreview" class="photo"></td>
              </tr>
              <tr>
                <th>Deeplink hash</th>
                <td>{{ business.deeplink_hash }}</td>
              </tr>
              <tr>
                <th>Verified</th>
                <td>{{ business.is_verified ? 'Yes': 'No' }}</td>
              </tr>
              <tr>
                <th>Open</th>
                <td>{{ business.is_open ? 'Yes' : 'No' }}</td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>



      <div class="row">
        <div class="col m6">
          <div class="switch">
            <label>
              Verified
              <input type="checkbox" v-model="business.is_verified">
              <span class="lever"></span>
            </label>
          </div>
        </div>

        <div class="col m6">
          <div class="switch">
            <label>
              Open
              <input type="checkbox" v-model="business.is_open">
              <span class="lever"></span>
            </label>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col m4 offset-m4">
          <a class="waves-effect waves-light btn" @click="update" :disabled="isSending">Update</a>
        </div>
      </div>
    </div>

  </root>
</template>

<script>
import * as firebase from "firebase";

export default {
  data() {
    return {
      business: {
        key: "",
        name: {
          en: "",
          ar: "",
        },
        description: {
          en: "",
          ar: "",
        },
        delivery_time: {
          en: "",
          ar: "",
        },
        cities: [],
        is_verified: false,
        is_open: false,
        deeplink_hash: "",
        //timestamp: firebase.database.ServerValue.TIMESTAMP,
        user_key: null,
        name_lower_case: null,
        is_cover_photo_updated: false,
        is_display_photo_updated: false
      },

      isSending: false,
      cities: [],
      city: "",
      displayPhotoPreview: "",
      coverPhotoPreview: "",
      deeplinks: [],
    };
  },

  methods: {
    // Collect
    collectBusiness() {
      firebase
        .database()
        .ref("businesses/" + this.$route.params.businessKey)
        .once("value")
        .then((businessSnap) => {
          let business = businessSnap.val();

          // Available cities
          firebase
            .database()
            .ref("countries/" + business.country + "/cities")
            .once("value")
            .then((citiesSnap) => {
              citiesSnap.forEach((citySnap) => {
                // Data
                let cityData = citySnap.val();
                cityData["key"] = citySnap.key;

                this.cities.push(cityData);
              });

              // Bind
              this.$nextTick(() => {
                this.business.key = businessSnap.key;
                this.business.name = business.name;
                this.business.description = business.description;
                this.business.delivery_time = business.delivery_time;
                this.business.is_verified = business.is_verified;
                this.business.is_open = business.is_open;
                this.business.cities = business.cities;
                this.business.deeplink_hash = business.deeplink_hash;
                this.business.user_key = business.user_key;
                this.business.is_cover_photo_updated = business.is_cover_photo_updated;
                this.business.is_display_photo_updated = business.is_display_photo_updated;
                this.business.name_lower_case = business.name_lower_case;
                

                // Display photo
                var displayPhotoKey = null;
                if (business.is_display_photo_updated == true) {
                  displayPhotoKey = businessSnap.key;
                } else {
                  displayPhotoKey = business.old_key;
                }

                firebase
                  .storage()
                  .ref("business/display/" + displayPhotoKey + ".jpeg")
                  .getDownloadURL()
                  .then((display) => {
                    this.displayPhotoPreview = display + ".jpeg";
                  })
                  .catch((error) => {
                    // A full list of error codes is available at
                    // https://firebase.google.com/docs/storage/web/handle-errors
                    switch (error.code) {
                      case "storage/object-not-found":
                        console.log("File doesn't exist");
                        break;
                      case "storage/unauthorized":
                        console.log(
                          "User doesn't have permission to access the object"
                        );
                        break;
                      case "storage/canceled":
                        console.log("User canceled the upload");
                        break;
                      case "storage/unknown":
                        console.log(
                          "Unknown error occurred, inspect the server response"
                        );
                        break;
                    }
                  });

                // Cover photo
                var coverPhotoKey = null;
                if (business.is_cover_photo_updated == true) {
                  coverPhotoKey = businessSnap.key;
                } else {
                  coverPhotoKey = business.old_key;
                }

                firebase
                  .storage()
                  .ref("business/cover/" + coverPhotoKey + ".jpeg")
                  .getDownloadURL()
                  .then((cover) => {
                    this.coverPhotoPreview = cover + ".jpeg";
                  })
                  .catch((error) => {
                    // A full list of error codes is available at
                    // https://firebase.google.com/docs/storage/web/handle-errors
                    switch (error.code) {
                      case "storage/object-not-found":
                        console.log("File doesn't exist");
                        break;
                      case "storage/unauthorized":
                        console.log(
                          "User doesn't have permission to access the object"
                        );
                        break;
                      case "storage/canceled":
                        console.log("User canceled the upload");
                        break;
                      case "storage/unknown":
                        console.log(
                          "Unknown error occurred, inspect the server response"
                        );
                        break;
                    }
                  });

                this.collectDeeplinks();
              });
            });
        });
    },

    // Update
    update() {
      // All fields are required
      if (
        !this.business.key ||
        !this.business.name.en ||
        !this.business.name.ar ||
        !this.business.description.en ||
        !this.business.description.ar ||
        !this.business.delivery_time.en ||
        !this.business.delivery_time.ar ||
        !this.business.cities.length ||
        !this.business.deeplink_hash
      )
        return Materialize.toast("All fields are required", 4000);

      // Prevent invalid userkey
      if (!this.$route.params.businessKey) {
        return Materialize.toast("Business is not valid", 4000);
      }

      // Check unique deeplink hash
      if (_.includes(this.deeplinks, this.business.deeplink_hash))
        return Materialize.toast("Deeplink already exists", 4000);

      this.isSending = true;

      this.business.name_lower_case = this.business.name.en.replace(/\s/g, "").trim().toLowerCase();

      // Pull out key
      let businessKey = this.business.key;
      delete this.business.key;

      // Push
      firebase
        .database()
        .ref("businesses/" + businessKey)
        .update(this.business)
        .then(() => {
          Materialize.toast("Updated", 4000);
          this.$router.push({ name: "Businesses" });
        });
    },

    // Choose city
    chooseCity() {
      this.business.cities.push(this.city);
    },

    // Unchoose city
    unchooseCity(key) {
      let index = this.business.cities.indexOf(key);
      this.business.cities.splice(index, 1);
    },

    // City name from key
    __cityName(key) {
      let city = _.find(this.cities, { key });
      return city.name.en;
    },

    // Check choosen city
    __isChoosen(key) {
      let choosenCities = this.business.cities;
      return choosenCities.includes(key) ? true : false;
    },

    // Upload display photo
    uploadPhoto(type, event) {
      // Collect photo
      let photo = event.target.files || event.dataTransfer.files;

      // Validate
      if (!photo.length || !this.business.key) {
        Materialize.toast("Unable to upload " + type + " photo", 4000);
        return;
      }

      var reader = new FileReader();
      reader.onload = (e) => {
        if (type == "display") {
          return (this.displayPhotoPreview = e.target.result);
        }
        this.coverPhotoPreview = e.target.result;
      };

      reader.readAsDataURL(photo[0]);

      // Upload photo
      firebase
        .storage()
        .ref("business/" + type + "/" + this.business.key + ".jpeg")
        .put(photo[0])
        .then((photoSnap) => {
          Materialize.toast("Uploaded " + type + " photo", 4000);

          if (type == "display") {
            firebase.database().ref('businesses/' + this.business.key).update({ is_display_photo_updated: true });
          } 
          else if (type == "cover") {
            firebase.database().ref('businesses/' + this.business.key).update({ is_cover_photo_updated: true });
          }
          
        });
    },

    collectDeeplinks() {
      firebase
        .database()
        .ref("businesses")
        .once("value")
        .then((businessesSnap) => {
          businessesSnap.forEach((businessSnap) => {
            this.deeplinks.push(businessSnap.val().deeplink_hash);
          });
          _.pull(this.deeplinks, this.business.deeplink_hash);
        });
    },
  },

  // Mounted
  mounted() {
    this.collectBusiness();
  },
};
</script>

<style lang="scss">
.admin-business-edit {
  .switch {
    display: flex;
    justify-content: center;
  }

  .photo {
    height: 75px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/BusinessEdit.vue